"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeHashHighlightManager = exports.HashHighlightManager = void 0;
/**
 * Highlight elements based on URL hash matching a data attribute.
 */
class HashHighlightManager {
    /**
     * Initialize the hash highlight system.
     * Finds all elements with `data-highlight-on-hash-match` and toggles
     * the class specified in `data-highlight-on-hash-match-class` when the URL hash matches.
     */
    static init() {
        document.addEventListener('DOMContentLoaded', () => {
            const items = document.querySelectorAll('[data-highlight-on-hash-match]');
            if (!items.length)
                return;
            const updateHighlights = () => {
                const currentHash = decodeURIComponent(location.hash.replace(/^#/, ''));
                items.forEach(item => {
                    var _a;
                    const targetHash = item.dataset.highlightOnHashMatch;
                    const activeClass = (_a = item.dataset.highlightOnHashMatchClass) !== null && _a !== void 0 ? _a : 'is-current';
                    const shouldBeActive = targetHash === currentHash;
                    item.classList.toggle(activeClass, shouldBeActive);
                });
            };
            window.addEventListener('hashchange', updateHighlights);
            updateHighlights(); // initial check
        });
    }
}
exports.HashHighlightManager = HashHighlightManager;
HashHighlightManager.lastManualHashChange = 0;
function initializeHashHighlightManager() {
    HashHighlightManager.init();
}
exports.initializeHashHighlightManager = initializeHashHighlightManager;
